import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/40">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Link to="/" className="inline-block">
              <span className="text-3xl font-heading font-black text-primary-500 tracking-tight">
                韩漫网
              </span>
            </Link>
            <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-sm">
              韩漫网致力于为广大漫画爱好者提供最新、最全的韩国漫画在线阅读服务。无需注册，完全免费，随时随地享受漫画阅读的乐趣。
            </p>
            <div className="flex items-center gap-3 mt-6">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-bilibili-line', 'ri-tiktok-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/50 text-foreground-400 hover:text-primary-400 hover:bg-background-300/50 transition-colors cursor-pointer"
                  aria-label="社交媒体"
                  rel="nofollow"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-label font-semibold text-foreground-600 uppercase tracking-wider mb-5">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              {[
                { to: '/', label: '首页' },
                { to: '/category/rexue', label: '热血漫画' },
                { to: '/category/aiqing', label: '爱情漫画' },
                { to: '/category/qihuan', label: '奇幻漫画' },
                { to: '/category/danmei', label: '耽美漫画' },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-label font-semibold text-foreground-600 uppercase tracking-wider mb-5">
              关于我们
            </h4>
            <div className="flex flex-col gap-2.5">
              {[
                { to: '/about', label: '品牌介绍' },
                { to: '/about', label: '联系方式' },
                { to: '/about', label: '用户口碑' },
                { to: '/about', label: '常见问题' },
              ].map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-label font-semibold text-foreground-600 uppercase tracking-wider mb-5">
              联系方式
            </h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center shrink-0">
                  <i className="ri-map-pin-line text-foreground-400 text-lg"></i>
                </div>
                <p className="text-sm text-foreground-400 leading-relaxed">
                  北京市朝阳区望京SOHO T1-1206
                </p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-foreground-400 text-lg"></i>
                </div>
                <p className="text-sm text-foreground-400">+86 10-8888-6666</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-foreground-400 text-lg"></i>
                </div>
                <p className="text-sm text-foreground-400">hello@ynbskj.cn</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/40">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 韩漫网 - 韩漫免费漫画在线阅读平台. 保留所有权利.
          </p>
          <div className="flex items-center gap-5">
            {['隐私政策', '服务条款', '免责声明'].map((label) => (
              <a
                key={label}
                href="#"
                className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap"
                rel="nofollow"
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}